export default "__VITE_ASSET__BKTC8aSj__"